import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { logErr } from "../lib/utils-trel";

export default function ForgotPassword(){
  const [step, setStep] = useState("request");
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  const [newPw, setNewPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const requestReset = async () => {
    setBusy(true); setErr(""); setMsg("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      if (data.dev_token) {
        setToken(data.dev_token);
        setMsg("Reset token generated (dev mode). Use it below.");
      } else {
        setMsg("If this email exists, a reset link has been sent.");
      }
      setStep("reset");
    } catch (e) { setErr("Could not start reset"); logErr("forgot pw", e); }
    setBusy(false);
  };

  const submit = async () => {
    setBusy(true); setErr(""); setMsg("");
    if (newPw !== confirm) { setErr("Passwords do not match"); setBusy(false); return; }
    try {
      await api.post("/auth/reset-password", { token, new_password: newPw });
      setMsg("Password updated. You can log in now.");
      setStep("done");
    } catch (e) { setErr(e.response?.data?.detail || "Reset failed"); logErr("reset pw", e); }
    setBusy(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-10 bg-[#FFF8EE]">
      <div className="w-full max-w-md">
        <Link to="/" className="font-serif text-3xl">TREL</Link>
        <h1 className="font-serif text-3xl mt-8">Reset password</h1>

        {step === "request" && (
          <div className="mt-6 space-y-5">
            <div>
              <label className="text-xs uppercase tracking-widest text-[#064E3B]/70">Email</label>
              <input data-testid="forgot-email" type="email" value={email} onChange={e=>setEmail(e.target.value)} className="kbd-input"/>
            </div>
            <button data-testid="forgot-submit" onClick={requestReset} disabled={busy || !email} className="btn-coral w-full">{busy?"Sending…":"Send reset link"}</button>
          </div>
        )}
        {step === "reset" && (
          <div className="mt-6 space-y-5">
            <div>
              <label className="text-xs uppercase tracking-widest text-[#064E3B]/70">Reset token</label>
              <input data-testid="reset-token" value={token} onChange={e=>setToken(e.target.value)} className="kbd-input"/>
            </div>
            <div>
              <label className="text-xs uppercase tracking-widest text-[#064E3B]/70">New password</label>
              <input data-testid="reset-new-pw" type="password" value={newPw} onChange={e=>setNewPw(e.target.value)} className="kbd-input"/>
            </div>
            <div>
              <label className="text-xs uppercase tracking-widest text-[#064E3B]/70">Confirm password</label>
              <input data-testid="reset-confirm-pw" type="password" value={confirm} onChange={e=>setConfirm(e.target.value)} className="kbd-input"/>
            </div>
            <button data-testid="reset-submit" onClick={submit} disabled={busy} className="btn-coral w-full">{busy?"Resetting…":"Update password"}</button>
          </div>
        )}
        {step === "done" && (
          <div className="mt-6">
            <Link to="/login" className="btn-coral">Go to login →</Link>
          </div>
        )}

        {msg && <div className="mt-5 text-sm text-[#064E3B]">{msg}</div>}
        {err && <div className="mt-5 text-sm text-[#FF7A45]">{err}</div>}
        <div className="text-sm text-center mt-8"><Link to="/login" className="underline">Back to login</Link></div>
      </div>
    </div>
  );
}
